import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useAuthStore } from '@/store/authStore';
import { validatePhoneNumber } from '@/utils/validation';

interface LoginFormData {
  phoneNumber: string;
  otp: string;
}

export function LoginForm() {
  const [isOtpSent, setIsOtpSent] = useState(false);
  const { login, isLoading, error } = useAuthStore();
  const navigate = useNavigate();
  
  const { register, handleSubmit, watch, formState: { errors } } = useForm<LoginFormData>();
  const phoneNumber = watch('phoneNumber');

  const onSubmit = async (data: LoginFormData) => {
    try {
      const success = await login(data.phoneNumber, data.otp);
      if (success) {
        navigate('/dashboard');
      }
    } catch (error) {
      console.error('Login error:', error);
    }
  };

  const handleSendOTP = () => {
    // In development, just show the OTP field
    setIsOtpSent(true);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
      <div className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="phoneNumber">رقم الجوال</Label>
          <Input
            id="phoneNumber"
            type="tel"
            dir="ltr"
            className="text-left"
            {...register('phoneNumber', {
              required: 'رقم الجوال مطلوب',
              validate: validatePhoneNumber
            })}
            placeholder="05xxxxxxxx"
          />
          {errors.phoneNumber && (
            <p className="text-sm text-red-500">{errors.phoneNumber.message}</p>
          )}
        </div>

        {!isOtpSent ? (
          <Button 
            type="button" 
            onClick={handleSendOTP}
            className="w-full"
            disabled={!phoneNumber || !!errors.phoneNumber}
          >
            إرسال رمز التحقق
          </Button>
        ) : (
          <div className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="otp">رمز التحقق</Label>
              <Input
                id="otp"
                type="text"
                inputMode="numeric"
                dir="ltr"
                className="text-left text-center tracking-widest"
                {...register('otp', { 
                  required: 'رمز التحقق مطلوب',
                  minLength: { value: 6, message: 'يجب أن يتكون الرمز من 6 أرقام' }
                })}
                placeholder="123456"
                maxLength={6}
              />
              {errors.otp && (
                <p className="text-sm text-red-500">{errors.otp.message}</p>
              )}
            </div>

            <Button type="submit" className="w-full" disabled={isLoading}>
              {isLoading ? 'جاري تسجيل الدخول...' : 'دخول'}
            </Button>
          </div>
        )}
      </div>

      {error && (
        <p className="text-sm text-red-500 text-center">{error}</p>
      )}

      <p className="text-xs text-gray-500 text-center">
        رمز التحقق للتجربة هو: 123456
      </p>
    </form>
  );
}